import * as React from 'react';
import { SVGProps } from 'react';

const PlusIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg width={16} height={16} xmlns="http://www.w3.org/2000/svg" {...props}>
    <title>{'Plus_Large'}</title>
    <g stroke="#000" strokeWidth={2} fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7.929 1.262v13.334M14.596 7.929H1.262" />
    </g>
  </svg>
);

export default PlusIcon;